import { ShieldCheck } from '@liveauctioneers/hammer-ui-core/icons';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { BodySecondary, LabelStrong } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { TrackingEvents } from '@/utils/amplitude/analytics/core.types';
import { useTrackPurchaseProtectionLearnMoreAnalytics } from '@/utils/amplitude/analytics/purchaseProtection/trackPurchaseProtectionLearnMore.analytics';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getPurchaseProtectionUrl } from '@/utils/urls';

type Props = {
    className?: string;
};

export const CatalogPurchaseProtectionLine = ({ className }: Props) => {
    const formatMessage = useAppFormatMessage();
    const trackPurchaseProtectionLearnMoreAnalytics = useTrackPurchaseProtectionLearnMoreAnalytics();

    const handleLearnMoreClick = () => {
        trackPurchaseProtectionLearnMoreAnalytics(TrackingEvents.PurchaseProtection.LearnMorePurchaseProtection, {
            description:
                'User clicks on the "Learn More" link in the "Purchase Protection" section on the catalog page',
        });
    };

    return (
        <div className={cn('flex items-start gap-xs', className)}>
            <ShieldCheck
                className="shrink-0"
                color="success"
                size="sm"
                style="fill"
            />
            <div>
                <LabelStrong>
                    {formatMessage(['catalogPage', 'catalogDetailsZone', 'purchaseProtectionTitle'])}
                </LabelStrong>{' '}
                <BodySecondary className="inline">
                    {formatMessage(['catalogPage', 'catalogDetailsZone', 'purchaseProtectionDescription'])}
                </BodySecondary>{' '}
                <Link
                    href={getPurchaseProtectionUrl()}
                    onClick={handleLearnMoreClick}
                    size="sm"
                >
                    {formatMessage(['catalogPage', 'catalogDetailsZone', 'purchaseProtectionLearnMore'])}
                </Link>
            </div>
        </div>
    );
};
